import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';

export const SubscriptionSuccessSnackbarMessage = () => {
  return (
    <Box display='flex' flexDirection='column' rowGap='2px'>
      <Typography variant='bodySmall' color={COLORS.grey[200]} fontWeight='medium'>
        Your Subscription is Active.
      </Typography>
      <Typography variant='caption' color={COLORS.grey[200]} fontWeight='medium'>
        Thank you! Your payment was successful. You can now start using your plan.
      </Typography>
    </Box>
  );
};
